import React, { Component } from "react";

import styles from "./styles.scss";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";

import CSSModules from "react-css-modules";
import { Button, CircularProgress, Checkbox, FormControlLabel } from "@material-ui/core";
import { DateTime } from "../../utils";
import { Link } from "react-router-dom";
import { Route, Switch } from "react-router";
import ImportStatus from "./ImportStatus/ImportStatus";

import aa_shape from "../../assets/Svgs/aa-shape.svg";

import pending_icon from "../../assets/Svgs/import-status-icons/pending.svg";
import importing_icon from "../../assets/Svgs/import-status-icons/inprogress.svg";
import config_incomplete_icon from "../../assets/Svgs/import-status-icons/config.svg";
import success_icon from "../../assets/Svgs/import-status-icons/complete.svg";
import failed_icon from "../../assets/Svgs/import-status-icons/failed.svg";


@CSSModules(styles, { allowMultiple: true })
class ImportOverview extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showStack: false
    };
  }

  componentDidMount() {

    this._inputRef = React.createRef();

    const from = DateTime.add("day", DateTime.startOf("day"), -14);
    const to = DateTime.endOf("day");

    this.props.notifyOnPage();
    this.props.queryHistory(from, to);
    this.props.startQueryHistoryPolling(from, to);
  }

  componentWillUnmount() {
    this.props.notifyLeftPage();
  }

  uploadFile(result) {
    console.log("uploading: ", result, result.target.files);
    this.props.upload(result.target.files);
  }

  componentDidUpdate(oldProps) {

  }

  render() {

    return (

      <div styleName="content-grid">

        {/* Left-side*/}
        <div styleName="left-side-container">

          {/* Mode switcher */}
          <div styleName="mode-switcher">
            {/*<Link to={`${match.url}/Upload`}>Import</Link>*/}
            {/*<Link to={`${match.url}/Config`}>Master RUles</Link>*/}
          </div>

          {/* History view (always present?) */}
          <div>

            <h2>Import History and Status</h2>

            <div styleName="import-history-grid">

              {this.props.refreshingHistory && <div class={"center-children full-height"}><CircularProgress /></div>}

              {!this.props.refreshingHistory && this.props.history && this.props.history.map(x => {
                return (
                  <Link to={`/MasterRules/Import/Status/${x.ruleImportStatusId}/Overview`}
                        key={x.ruleImportStatusId}>
                    <div styleName={"import-history-card clickable"}>
                      <span>{x.fileName}</span>

                      { x.status === "pending" && <img src={pending_icon} class={"import-status-icon"}/>}
                      { x.status === "importing" && <img src={importing_icon} class={"import-status-icon"}/>}
                      { x.status === "config_incomplete" && <img src={config_incomplete_icon} class={"import-status-icon"}/>}
                      { x.status === "complete" && <img src={success_icon} class={"import-status-icon"}/>}
                      { x.status === "failed" && <img src={failed_icon} class={"import-status-icon"}/>}

                    </div>
                  </Link>
                );
              })}

            </div>
          </div>

        </div>

        <div styleName="right-side-container">

          <Switch>
            <Route path={`/MasterRules/Import/Status/:id`} component={ImportStatus} key="import-status-fifjio">
            </Route>
            {/*TODO: This might be nice as its own component*/}
            <Route path={`/MasterRules/Import/`}>
              <div style={{display: "grid"}}>

                <Button variant="raised"
                        styleName="switch-button"
                        onClick={() => this.props.navigate("/Import/Spreadsheet")}>
                  Switch to Single (Old) Import
                </Button>

                {/* Console + Upload Button */}
                <div styleName="console">

                  {!this.props.isBusy && !this.props.importAttempted &&

                    <div class="center-children full-height">
                      <span>Use the 'Upload Spreadsheet' button below to upload 1 or more spreadsheets</span>
                    </div>

                  }

                  {(this.props.isBusy || this.props.importAttempted) &&
                    this.props.output.map((x, i) => {
                      //regex matches any number of whitespace, at start, then %C or %E or %S
                      const comment = /^[^\S]*%C/.test(x);
                      const error = /^[^\S]*%E/.test(x);
                      const stack = /^[^\S]*%S/.test(x);
                      const warn = /^[^\S]*%W/.test(x);

                      if (stack && !this.state.showStack) {
                        return null;
                      }

                      let prints = x.replace(/^[^\S]*%C|^[^\S]*%E|^[^\S]*%S|^[^\S]*%W/, "").split("\n");

                      if (prints.length > 1) {
                        //replace newline with <br/>
                        prints = prints.map((x, i) => (
                          <React.Fragment key={i}>
                            {x}
                            <br/>
                          </React.Fragment>
                        ));
                      }

                      return (
                        <div
                          key={i}
                          styleName={`line ${
                            error
                              ? "line-error"
                              : comment
                                ? "line-green"
                                : stack
                                  ? "line-yellow"
                                  : warn
                                    ? "line-warn"
                                    : "line-black"
                          }`}
                        >
                          {prints}
                        </div>
                      );
                    })}
                </div>


                {(!this.props.isBusy && this.props.uploadedStatusLinks.length > 0) &&
                  <div>

                    Links to Import Status:

                    <div styleName="uploaded-imports">

                      {this.props.uploadedStatusLinks.map((x, i) => {
                        return (
                          <Link to={`/MasterRules/Import/Status/${x.id}/Overview`}
                                key={x.ruleImportStatusId}>
                            <div styleName={"import-history-card clickable pending"}>
                              <span>{x.fileName}</span>
                            </div>
                          </Link>
                        );
                      })}

                    </div>

                  </div>
                }


                {/* Controls */}
                <div styleName="wraps">
                  {this.props.isBusy && <CircularProgress/>}

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.showStack}
                        onChange={e => {
                          this.setState({ showStack: !this.state.showStack });
                        }}
                        color="primary"
                      />
                    }
                    label="Show Stacktrace"
                  />

                  {/* Note: The 'ref' attribute here is used to get a reference to this 'input' (which is hidden) */}
                  {/* for use in our actual 'upload spreadsheet' button (and later, drag n drop upload component) */}
                  <input
                    type="file"
                    multiple
                    onChange={s => {
                      this.uploadFile(s);
                      this._inputRef.current.value = "";
                    }}
                    ref={this._inputRef}
                    style={{ display: "none" }}
                  />

                  <Button variant="raised" onClick={() => this._inputRef.current.click()}>
                    Upload Spreadsheet
                  </Button>
                  <Button variant="raised" onClick={() => this.props.clear()}>
                    Clear Console
                  </Button>
                </div>
              </div>
            </Route>

          </Switch>


        </div>

      </div>

    );
  }
}

const bindAction = dispatch => {
  return {

    notifyOnPage: () => dispatch(actions.notifyOnPage()),
    notifyLeftPage: () => dispatch(actions.notifyLeftPage()),

    startQueryHistoryPolling: (from, to) => dispatch(actions.startQueryHistoryPolling(from, to)),
    queryHistory: (from, to) => dispatch(actions.queryHistory(from, to)),

    upload: s => dispatch(actions.upload(s)),
    clear: () => dispatch(actions.clear()),

    navigate: (uri, data) => dispatch(router.push(uri, data)),
    goBack: () => dispatch(router.goBack())
  };
};

const mapStateToProps = state => ({
  refreshingHistory: state.importOverview.refreshingHistory,
  history: state.importOverview.history,
  output: state.importOverview.output,
  isBusy: state.importOverview.isBusy,
  errors: state.importOverview.errors,
  importAttempted: state.importOverview.importAttempted,
  uploadedStatusLinks: state.importOverview.uploadedStatusLinks,
});

export default connect(
  mapStateToProps,
  bindAction
)(ImportOverview);



// WEBPACK FOOTER //
// ./src/ui/ImportOverview/ImportOverview.js